export default {
	isEmail
};

function isEmail(str) {
	return str.search(/^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/) != -1;
}
